<parkour-icon class="inline-flex" name="badge-on" />
